// client/frontend-helpers/window-size.ts
import { BehaviorSubject, combineLatest, fromEvent, interval, Subject, timer } from "rxjs";
import { distinctUntilChanged, map, shareReplay, startWith, take } from "rxjs/operators";
var getUserAgent = () => {
  return navigator.userAgent || navigator.vendor || window.opera;
};
var isMobile = () => {
  var check = false;
  (function(a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
      a
    ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      a.substr(0, 4)
    ))
      check = true;
  })(getUserAgent());
  return check;
};
var isMobileOrTablet = () => {
  var check = false;
  (function(a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
      a
    ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      a.substr(0, 4)
    ))
      check = true;
  })(getUserAgent());
  return check;
};
var isIos = () => {
  return /iPad|iPhone|iPod/.test(getUserAgent()) && !window.MSStream || navigator.platform === "MacIntel";
};
var isAndroid = () => {
  return getUserAgent().toLowerCase().indexOf("android") > -1;
};
var isSafari = () => {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document || // generell safari detection
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
var manuallySetPrinting = new BehaviorSubject(false);
var origPrint = window.print;
window.print = function() {
  manuallySetPrinting.next(true);
  setTimeout(() => {
    origPrint();
    manuallySetPrinting.next(false);
  }, 1e3);
};
var mediaQueryList = window.matchMedia("print");
var mediaQueryListenerSubject = new Subject();
mediaQueryList.addListener((e) => {
  mediaQueryListenerSubject.next(e.matches);
});
var isPrinting = combineLatest([mediaQueryListenerSubject.pipe(startWith(false)), manuallySetPrinting]).pipe(
  map(([matches, manual]) => matches || manual),
  shareReplay(1)
);
var BreakPoint = /* @__PURE__ */ ((BreakPoint2) => {
  BreakPoint2[BreakPoint2["smallPhone"] = 0] = "smallPhone";
  BreakPoint2[BreakPoint2["phone"] = 1] = "phone";
  BreakPoint2[BreakPoint2["bigPhone"] = 2] = "bigPhone";
  BreakPoint2[BreakPoint2["tablet"] = 3] = "tablet";
  BreakPoint2[BreakPoint2["laptop"] = 4] = "laptop";
  BreakPoint2[BreakPoint2["desktopSmall"] = 5] = "desktopSmall";
  BreakPoint2[BreakPoint2["huge"] = 6] = "huge";
  return BreakPoint2;
})(BreakPoint || {});
var mapping = {
  0: 414,
  1: 576,
  2: 768,
  3: 992,
  4: 1300,
  5: 1600,
  6: Infinity
};
var getDevice = (width = null) => {
  const appWidth = window.innerWidth;
  if ((width !== null ? width : appWidth) < mapping[0 /* smallPhone */])
    return 0 /* smallPhone */;
  if ((width !== null ? width : appWidth) < mapping[1 /* phone */])
    return 1 /* phone */;
  if ((width !== null ? width : appWidth) < mapping[2 /* bigPhone */])
    return 2 /* bigPhone */;
  if ((width !== null ? width : appWidth) < mapping[3 /* tablet */])
    return 3 /* tablet */;
  if ((width !== null ? width : appWidth) < mapping[4 /* laptop */])
    return 4 /* laptop */;
  if ((width !== null ? width : appWidth) < mapping[5 /* desktopSmall */])
    return 5 /* desktopSmall */;
  if ((width !== null ? width : appWidth) < mapping[6 /* huge */])
    return 6 /* huge */;
  return 0 /* smallPhone */;
};
var windowResize = combineLatest([
  fromEvent(window.visualViewport || window, "resize").pipe(startWith(null)),
  isSafari() ? interval(200).pipe(take(5)) : timer(0)
  // hack for in app instagram browser, sometimes reports desktop size shortly after loading
]).pipe(shareReplay(1));
var listenChanges = windowResize.pipe(
  map((_) => getDevice()),
  distinctUntilChanged()
);
var listenDevice = new BehaviorSubject(getDevice());
listenChanges.subscribe(listenDevice);
var windowSize = windowResize.pipe(
  map(() => ({
    device: getDevice(),
    height: window.visualViewport?.height ?? window.innerHeight,
    width: window.innerWidth
  })),
  distinctUntilChanged((a, b) => a.device === b.device && a.height === b.height && a.width === b.width)
);
var rotation = fromEvent(window, "resize").pipe(
  startWith(null),
  map(() => window.innerHeight / window.innerWidth > 1 ? "portrait" : "landscape")
);
export {
  BreakPoint,
  getDevice,
  isAndroid,
  isIos,
  isMobile,
  isMobileOrTablet,
  isPrinting,
  isSafari,
  listenDevice,
  manuallySetPrinting,
  mapping,
  rotation,
  windowResize,
  windowSize
};
